import { Api } from './Api';

/**
 * Api is expected to be used as a singleton, hence the class is not exported
 * and the default export is an instance of this class.
 */
const apiInstance = new Api();
export default apiInstance;
